import React from 'react';
export function TopBar() {
  return <div className="sticky top-0 z-50 bg-primary text-black py-2 px-4 text-center font-space-grotesk font-bold text-sm md:text-base shadow-md" data-id="element-348">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2" data-id="element-349">
        <span data-id="element-350">🏋️</span>
        <span data-id="element-351">COMPRA DIGITAL YA™</span>
      </div>
    </div>;
}